/* Claude QA 10-9 / 10-21 (v12)
   A. Top loading bar: starts when you click an internal link, finishes on the next page.
      11-03 (v15): cleared again when the click opens a drawer instead of loading a page.
   B. Cohort 001 popup: after it is closed (or was closed on an earlier visit) a small "Join Cohort 001"
      tab sits bottom-left (hidden on product pages and the cart); tapping it brings the popup back.
      After a successful sign-up the popup is shown with its success state and the tab is retired. */
(function () {
  var KEY_NAV = 'amTopbar';
  var KEY_JOINED = 'amCohortJoined';

  function store(get, k, v) {
    try {
      if (get) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function sess(get, k, v) {
    try {
      if (get) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  /* ---------- A. Top bar ---------- */
  function topbar() {
    var bar = document.createElement('div');
    bar.className = 'am-topbar';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    // Landing: finish the bar started on the previous page.
    if (sess(true, KEY_NAV)) {
      sess(false, KEY_NAV, null);
      bar.classList.add('is-landing');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { bar.classList.add('is-done'); });
      });
      setTimeout(function () { bar.className = 'am-topbar'; }, 900);
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.getAttribute('href').charAt(0) === '#') return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      if (a.closest('cart-drawer, .wt-drawer--nav .wt-page-nav-mega__link--parent, [data-no-topbar]')) return;
      bar.classList.remove('is-done', 'is-landing');
      void bar.offsetWidth;
      bar.classList.add('is-on');
      sess(false, KEY_NAV, '1');
      // 11-03 (v15): links that open a drawer instead of navigating (bag icon, menu, search) call
      // preventDefault after this capture listener runs, which left the bar stuck at 85%. Check once the
      // click has finished; if nothing is navigating, clear the bar.
      setTimeout(function () {
        if (e.defaultPrevented) { bar.className = 'am-topbar'; sess(false, KEY_NAV, null); }
      }, 0);
    }, true);

    // Back-forward cache or a cancelled navigation: clear the bar.
    window.addEventListener('pageshow', function () {
      setTimeout(function () { if (bar.classList.contains('is-on')) bar.className = 'am-topbar'; sess(false, KEY_NAV, null); }, 4000);
    });
  }

  /* ---------- B. Cohort tab ---------- */
  function cohort() {
    var section = document.querySelector('.not-pu-section');
    if (!section) return;
    var popup = section.querySelector('notification-popup');
    var subscribed = popup && popup.dataset.hasSubscription === 'true';
    var posted = /[?&]customer_posted=true/.test(location.search);

    if (posted && section.querySelector('.form__success-field')) {
      store(false, KEY_JOINED, '1');
      section.classList.add('is-posted');
      section.classList.remove('hidden');
      return;
    }
    if (subscribed || store(true, KEY_JOINED)) return;

    var tab = document.createElement('a');
    tab.href = '#';
    tab.className = 'am-cohort-tab';
    tab.hidden = true;
    tab.setAttribute('data-no-topbar', '');
    tab.innerHTML = 'Join Cohort 001 <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 8h12M9 3l5 5-5 5"/></svg>';
    document.body.appendChild(tab);

    function dismissed() {
      try {
        if (sessionStorage.getItem('hideNotificationPopup') === 'true') return true;
        return Number(localStorage.getItem('hideNotificationPopupUntil') || 0) > Date.now();
      } catch (e) { return false; }
    }

    // Already dismissed on an earlier visit: show the tab straight away.
    if (dismissed()) tab.hidden = false;

    // Dismissed now: the close button hides the popup, we show the tab.
    section.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.newsletter__close-btn')) setTimeout(function () { tab.hidden = false; }, 250);
    });

    tab.addEventListener('click', function (e) {
      e.preventDefault();
      try { sessionStorage.removeItem('hideNotificationPopup'); localStorage.removeItem('hideNotificationPopupUntil'); } catch (err) {}
      tab.hidden = true;
      section.classList.remove('hidden');
      section.classList.add('wt-popup-fade-in');
      var field = section.querySelector('.wt-newsletter__field');
      if (field) setTimeout(function () { field.focus(); }, 300);
    });
  }

  function start() { topbar(); cohort(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
